import { Unlink } from 'lucide-react';

import { GatewayBrand, GatewayContent, GatewayShell } from '@/_shared/components/GatewayShell';

/** Shown to anonymous viewers when the share token resolves to a dashboard
 * whose workspace flag is off, whose privacy was flipped back to private, or
 * was simply never valid. The same shape covers all three cases so the page
 * never reveals whether a token is real. */
export function PublicUnavailable(): React.ReactElement {
  return (
    <GatewayShell>
      <GatewayBrand />
      <GatewayContent
        icon={<Unlink />}
        variant="error"
        title="This link is unavailable."
        description="The dashboard owner may have unpublished the link or rotated it. Check with the person who shared it for an updated URL."
      />
    </GatewayShell>
  );
}
